import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject, Observable, catchError, map, of } from 'rxjs';
import { OptionImageProvider } from '../../common-features/services/option-image-providers/option-image-provider';

@Pipe({
    name: 'authImgSource',
    standalone: false
})
export class AuthImgSourcePipe implements PipeTransform {

  constructor(
    private domSanitizer: DomSanitizer) {

  }

  transform(value: string, provider: OptionImageProvider): Observable<any> {
    const placeHolder = this.domSanitizer.bypassSecurityTrustUrl(provider.getPlaceHolderUrl())
    const url = provider.getImage(value)
    const image$ = new BehaviorSubject(placeHolder)

    provider.getImage(value)
      .pipe(
        map(imageBlob => this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(imageBlob!))),
        catchError(e => {
          console.error('error loading image', url)
          return of(placeHolder)
        })

      ).subscribe(x => image$.next(x))

    return image$
  }

}
